import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  stack: (bgColor: string) => css`
    background-color: ${bgColor};
    padding-bottom: 64px;

    ${theme.breakpoints.down("sm")} {
      background-color: white;
      padding-bottom: 0px;
    }
  `,
  logo: css`
    margin-left: 80px;
    margin-top: 18px;
    margin-bottom: 25px;
    object-fit: contain;

    ${theme.breakpoints.down("sm")} {
      margin-left: 24px;
    }
  `,
  bullet: css`
    display: inherit;
    width: 32px;
    height: 32px;
    position: absolute;
    right: -18px;
    bottom: -16px;
    z-index: 2;

    ${theme.breakpoints.down("sm")} {
      display: none;
    }
  `,
  image: css`
    border-bottom-left-radius: 300px;

    ${theme.breakpoints.down("sm")} {
      border-bottom-left-radius: 12rem;
    }
  `,
  box__button: css`
    align-self: start;
    text-transform: none;
    font-size: 16px;
    font-weight: 600;
    height: 48px;
    min-width: 180px;
    margin-top: 24px;
    margin-bottom: 36px;
    color: #d5d5d5;
    border-radius: 6px;
    padding: 16px 36px;

    @media (max-width: 899px) {
      margin-top: 32px;
    }
  `
};
